import { functions } from '@/functions';

export const functions_price = {
    mixins: [functions],
    data: function () {
        return {
            prices:null,
            price:null,
            no_prices:null,
        }
    },

    methods: {

        loadPrices: function (room_id, onSuccess=null, param=null) {
            console.log('loadPrices 1')
            console.log(this.prices);
            if (!this.is_prices_loaded && room_id) {
                this.prices = [];
                let df = new Date();
                let dt = new Date();
                dt.setDate(dt.getDate()+360);
                df = df.toISOString().slice(0, 10);
                dt = dt.toISOString().slice(0, 10);
                this.httpPrepare();
                this.$http.get(this.apiurl('room/' + room_id + '/prices/'+df+'/'+dt)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.prices = response.payload;
                    if (!this.is_prices) {
                        this.no_prices = "Цен для выбранного номера не найдено"
                    }
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadPricesForHotel: function(hotel_id, onSuccess=null, param=null) {
            console.log(this.prices);
            if (!this.is_prices_loaded && hotel_id) {
                this.prices = [];
                let df = new Date();
                let dt = new Date();
                dt.setDate(dt.getDate()+360);
                df = df.toISOString().slice(0, 10);
                dt = dt.toISOString().slice(0, 10);
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/prices/'+df+'/'+dt)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.prices = response.payload;
                    if (!this.is_prices) {
                        this.no_prices = "Цен для выбранного отеля не найдено"
                    }
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadAllPrices: function(hotel_id, onSuccess=null, param=null) {
            console.log(this.prices);
            if (!this.is_prices_loaded && hotel_id) {
                this.prices = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/prices/all')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.prices = response.payload;
                    if (!this.is_prices) {
                        this.no_prices = "Цен для выбранного отеля не найдено"
                    }
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetPrices: function () {
            this.prices = null;
            this.no_prices = null;
            return this;
        },

        // isNoPrices: function () {
        //     return (this.no_prices !== null) && this.no_prices;
        // },

        priceComparator: function(room_id, tarif_id, period_id) {
            return function(element) {
                if (room_id) {
                    if (element.t_obj_rooms_id != room_id) {
                        return false;
                    }
                }
                if (tarif_id) {
                    if (element.t_obj_tariff_id != tarif_id) {
                        return false;
                    }
                }
                if (period_id) {
                    if (element.t_obj_period_id != period_id) {
                        return false;
                    }
                }
                return true;
            }
        },

        filteredPrices: function (room_id, tarif_id, period_id) {
            console.log('filteredPrices('+room_id + ','+tarif_id+','+period_id+')');
            return this.prices.filter(this.priceComparator(room_id, tarif_id, period_id))
        },


        enablePrice: function (price_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/' + price_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disablePrice: function (price_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/' + price_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deletePrice: function (price_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('price/' + price_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        createPrice: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('price/create/' + hotel_id  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        getPriceById: function (id, prices = null) {
            if (!this.is(id)) {
                return null;
            }

            if (prices === null) {
                prices = this.prices;
            }

            for (let i = 0; i < prices.length; i++) {
                if (prices[i].id === id) {
                    return prices[i];
                }
            }
            return null;
        },

        delPriceById: function (id, prices = null) {
            if (!this.is(id)) return false;
            if (prices === null) prices = this.prices;

            for (let i = 0; i < prices.length; i++) {
                if (prices[i].id === id) {
                    prices.splice(i, 1);
                    return true;
                }
            }
            return false;
        },

        loadPrice: function (price_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('price/' + price_id )).then(function (response) {
                response = this.httpSuccess(response);
                this.price = response.payload;
                this.executeFunction(onSuccess, param, this.price);
            }, this.httpError)
        },

        savePrice: function (price, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/' + price.id + '/save' ), price).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.notifyInfo('Цены сохранены');
                this.setLatestPrice(price.id);
            }, this.httpError)
        },

        latestPriceClass: function (price) {
            return this.isLatest('App\\Models\\Price', price.id) ? 'latest' : '';
        },
        setLatestPrice: function (id) {
            this.setLatest('App\\Models\\Price', id);
        },

        enablePriceMulti: function (prices, hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/enable' ), {ids:prices, hotel_id:hotel_id}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disablePriceMulti: function (prices, hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/disable' ), {ids:prices, hotel_id:hotel_id}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deletePriceMulti: function (prices, hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/delete' ), {ids:prices, hotel_id:hotel_id}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        resetPriceMulti: function (prices, hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('price/reset' ), {ids:prices, hotel_id:hotel_id}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },
    },

    computed: {
        is_prices_loaded: function () {
            return (this.prices !== null) && this.prices;
        },
        is_prices: function () {
            return (this.prices !== null) && this.prices && this.prices.length;
        },
        is_price_loaded: function () {
            return this.is(this.price);
        },
    }
};



